import { Component, OnInit, ViewChild, Output, EventEmitter } from "@angular/core";
import { SelectItem, LazyLoadEvent } from "primeng/primeng";
import { FiltroPersonamast } from "../../dominio/FiltroPersonamast";
import { PersonamastServicio } from "../../service/personamast.service";
import { Table } from 'primeng/table';

@Component({
    selector: 'personamast-selector',
    templateUrl: './personamastselector.component.html'
})
export class PersonamastSelectorComponent implements OnInit {

    @ViewChild(Table,{static:false}) dataTableComponent: Table;

    checked: boolean = true;
    noChecked: boolean = false;

    verSelector: Boolean = false;
    cargando: boolean = false;
    lstCriterios: SelectItem[] = [
        { value: 'NOMBRE_CORTO', label: 'Nombre corto' },
        { value: 'DOCUM_IDENTI', label: 'Doc. de Identidad' },
        { value: 'DOCUM_FISCAL', label: 'Documento Fiscal' },
        { value: 'DOCUM___ENTO', label: 'Documento' },
        { value: 'NUMERO_PERSO', label: 'Número Persona' },
        { value: 'CODIGO_ANTER', label: 'Código Anterior' },
        { value: 'TELE____FONO', label: 'Teléfono' }
    ];
    lstPyme: SelectItem[] = [
        { value: null, label: ' -- Todos --' },
        { value: 'S', label: 'Si' },
        { value: 'N', label: 'No' }
    ];
    filtro: FiltroPersonamast = new FiltroPersonamast();
    registrosPorPagina: number = 20;

    @Output() block = new EventEmitter();
    @Output() cancelarAccion = new EventEmitter();
    @Output() unBlock = new EventEmitter();
    @Output() cargarSeleccionEvent = new EventEmitter();

    constructor(private personamastServicio: PersonamastServicio) {

    }

    ngOnInit() {
        this.cargando = true;
    }

    iniciarComponente() {
        this.cargando = true;
        this.verSelector = true;
        this.filtro = new FiltroPersonamast();
    }

    seleccionar(row: any) {
        this.cancelar();
        this.cargarSeleccionEvent.emit(row);
    }

    cancelar() {
        this.verSelector = false;
        this.cancelarAccion.emit();
    }

    guardar() {

    }

    defaultBuscar(event?: any) {
        if (event.keyCode === 13) {
            this.buscar();
        }
    }

    buscar() {
        this.dataTableComponent.reset();
    }

    cargarPaginacion(event: LazyLoadEvent) {
        if (!this.verSelector) {
            return;
        }
        if (this.cargando) {
            this.cargando = false;
            return;
        }

        this.filtro.buscarDentro = "true";
        this.filtro.conInactivos = "true";

        this.block.emit();
        this.filtro.paginacion.listaResultado = [];
        this.filtro.paginacion.registroInicio = event.first;
        this.filtro.paginacion.cantidadRegistrosDevolver = event.rows;
        this.personamastServicio.listarPaginacion(this.filtro)
            .then(pg => {
                this.filtro.paginacion = pg;
                this.unBlock.emit();
            });
    }

}
